(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../modules/data/channels.js'),
            require('../enums/colors.js'),
            require('../enums/metrics.js'),
            require('../strings/strings.js'),
            require('../str.js'),
            require('../modules/utils/metric.js'),
            require('../modules/formatter.js'),
            require('../modules/metric/metric.js'),
            require('lodash'),
            require('../../lib/riq-moment.js')
        );

    } else {
        RivalIQ.metrics.definitions.twitter = exportFn(
            RivalIQ.data.channels,
            RivalIQ.enums.colors,
            RivalIQ.enums,
            RivalIQ.strings,
            RivalIQ.str,
            RivalIQ.utils.metric,
            RivalIQ.formatter,
            RivalIQ.metric,
            window._,
            window.moment
        );
    }

    function exportFn(channels, colors, metricEnums, strings, str, utils, formatter, metricFn, _, moment) {
        const channel = channels.get('twitter');

        return {
            className: channel.get('channel'),
            format: channel.get('name'),
            name: channel.get('name'),
            color: colors.twitterHighContrast,
            engagement_total: {
                name: 'Engagement Total',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS || metric.key === 'INSIGHTS_POSTS_SEARCH') {
                            return strings.twitter_insights_post_engagement_total_description;
                        }
                        return strings.twitter_tweet_details_engagement_total_description;
                    }
                    if (metric.dataSource === 'discovery') {
                        return strings.discovery_twitter_tweets_engagement_total_description;
                    } else if (metric.dataSource === 'insightsPost') {
                        return strings.twitter_insights_engagement_total_description;
                    }
                    return strings.twitter_tweets_engagement_total_description;
                },
                collection: metricEnums.collection.ENGAGEMENT
            },
            engagement_total_tweets_and_replies: {
                name: 'Engagement for Tweets & Replies',
                description: strings.twitter_tweets_engagement_total_tweets_and_replies_description,
                collection: metricEnums.collection.ENGAGEMENT
            },
            social_engagement_total: {
                name: 'Social Engagement Total',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        return strings.twitter_insights_post_social_engagement_total_description;
                    } else {
                        return strings.twitter_insights_social_engagement_total_description;
                    }
                },
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            social_engagement_total_tweets_and_replies: {
                name: 'Social Engagement for Tweets & Replies',
                description: strings.twitter_insights_social_engagement_total_tweets_and_replies_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            social_engagement_total_per_post: {
                name: 'Social Engagement Total / Tweet',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        return strings.twitter_insights_social_engagement_per_post_panel_description;
                    } else {
                        return strings.twitter_insights_social_engagement_total_per_post_description;
                    }
                },
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                summable: false
            },
            engagement_total_insights: {
                name: 'Engagement Total',
                description: strings.twitter_insights_engagement_total_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            engagement_total_tweets_and_replies_insights: {
                name: 'Engagement for Tweets & Replies',
                description: strings.twitter_insights_engagement_total_tweets_and_replies_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            engagement_total_per_post_insights: {
                name: 'Engagement Total / Tweet',
                description: strings.twitter_insights_engagement_total_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                summable: false
            },
            all_tweets: {
                name: 'All Tweets',
                description: strings.twitter_insights_all_tweets_description,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY
            },
            all_tweets_per_day: {
                name: 'All Tweets / Day',
                description: strings.twitter_insights_all_tweets_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            all_tweets_per_week: {
                name: 'All Tweets / Week',
                description: strings.twitter_insights_all_tweets_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                summable: false,
                format: function (val) {
                    if (_.isArray(val)) {
                        val = _.last(val);
                    }
                    return formatter.formats.fixed(val);
                }
            },
            replies_count: {
                name: 'Reply Tweets',
                description: strings.twitter_insights_replies_count_description,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY
            },
            replies_per_day: {
                name: 'Reply Tweets / Day',
                description: strings.twitter_insights_replies_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            replies_per_week: {
                name: 'Reply Tweets / Week',
                description: strings.twitter_insights_replies_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                format: function (val) {
                    if (_.isArray(val)) {
                        val = _.last(val);
                    }
                    return formatter.formats.fixed(val);
                },
                summable: false
            },
            retweets_count: {
                name: 'Retweet Tweets',
                description: strings.twitter_insights_retweets_count_description,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY
            },
            retweets_per_day: {
                name: 'Retweet Tweets / Day',
                description: strings.twitter_insights_retweets_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            retweets_per_week: {
                name: 'Retweet Tweets / Week',
                description: strings.twitter_insights_retweets_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                format: function (val) {
                    if (_.isArray(val)) {
                        val = _.last(val);
                    }
                    return formatter.formats.fixed(val);
                },
                summable: false
            },
            normal_tweets_count: {
                name: 'Tweets',
                description: strings.twitter_insights_normal_tweets_count_description,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY
            },
            normal_tweets_per_day: {
                name: 'Tweets / Day',
                description: strings.twitter_insights_normal_tweets_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            normal_tweets_per_week: {
                name: 'Tweets / Week',
                description: strings.twitter_insights_normal_tweets_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                format: function (val) {
                    if (_.isArray(val)) {
                        val = _.last(val);
                    }
                    return formatter.formats.fixed(val);
                },
                summable: false
            },
            total_impressions: {
                name: 'Total Impressions',
                description: strings.twitter_insights_total_impressions_description
            },
            total_impressions_per_post: {
                name: 'Impressions / Post',
                description: strings.twitter_insights_total_impressions_per_post_description,
                summable: false
            },
            engagement_rate_by_impression: {
                name: 'Engagement Rate by Impression',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        return strings.twitter_insights_post_engagement_rate_by_impression_description;
                    }
                    return strings.twitter_insights_engagement_rate_by_impression_description;
                },
                collection: metricEnums.collection.ENGAGEMENT,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            social_engagement_rate_by_impression: {
                name: 'Social Engagement Rate by Impression',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        return strings.twitter_insights_post_social_engagement_rate_by_impression_description;
                    }

                    return strings.twitter_insights_social_engagement_rate_by_impression_description;
                },
                collection: metricEnums.collection.ENGAGEMENT,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            engagement_rate_by_presence_reach: {
                name: 'Engagement Rate by Follower',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        return strings.twitter_insights_post_engagement_rate_by_presence_reach_description;
                    }
                    return strings.twitter_insights_engagement_rate_by_presence_reach_description;
                },
                collection: metricEnums.collection.ENGAGEMENT,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            engagement_total_per_post: {
                name: 'Engagement Total / Tweet',
                description: function (val, metric) {
                    if (metric.dataSource === 'insightsPost') {
                        return strings.twitter_insights_engagement_total_per_post_description;
                    } else {
                        return strings.twitter_engagement_total_per_post_description;
                    }
                },
                collection: metricEnums.collection.ENGAGEMENT,
                summable: false
            },
            engagement_rate: {
                description: function (val, metric) {
                    const useDetails = utils.useDetailsDescription(metric);
                    return useDetails ? strings.twitter_tweets_details_engagement_rate_description : strings.twitter_tweets_engagement_rate_description;
                }
            },
            avg_engagement_rate_per_post: {
                name: 'Engagement Rate by Follower',
                description: strings.twitter_average_tweet_engagement_rate_description
            },
            avg_activity_per_period: {
                // NOTE for context on naming see #15926, #16547
                name: 'Average Daily Tweets',
                summable: false
            },
            audience: {
                name: 'Followers',
                description: function (val, metric) {
                    if (metric.dataSource === 'discovery') {
                        return strings.discovery_twitter_presence_reach_description;
                    }
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_presence_reach_description;
                        }
                    }
                    return strings.twitter_presence_reach_description;
                },
                metricType: metricEnums.metricType.TOTAL,
                category: 'post_analysis',
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            presence_reach: {
                name: 'Followers',
                description: function (val, metric) {
                    if (metric.dataSource === 'discovery') {
                        return strings.discovery_twitter_presence_reach_description;
                    }
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_presence_reach_description;
                        }
                    }
                    return strings.twitter_presence_reach_description;
                },
                collection: function (data, metric) {
                    return (metricFn.hasDimension(metric, 'post') ? metricEnums.collection.GENERAL : metricEnums.collection.AUDIENCE);
                },
                noHistoricData: true,
                summable: false
            },
            potential_reach: {
                description: strings.twitter_potential_reach_description,
                noHistoricData: true,
                summable: false
            },
            all_avg_count_per_day: {
                name: 'All Tweets / Day',
                description: strings.twitter_average_daily_tweets_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                metricCategory: metricEnums.category.ACTIVITY,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            all_avg_count_per_week: {
                name: 'All Tweets / Week',
                description: strings.twitter_all_avg_count_per_week_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                metricCategory: metricEnums.category.ACTIVITY,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ACTIVITY,
                format: function (val) {
                    if (_.isArray(val)) {
                        val = _.last(val);
                    }
                    return formatter.formats.fixed(val);
                },
                summable: false
            },
            avg_engagement_total_per_day: {
                name: 'Engagement Total / Day',
                description: strings.twitter_average_tweet_engagement_total_description,
                summable: false
            },
            posts_per_hour: {
                name: 'Tweets per hour'
            },
            num_posts: {
                name: 'Number of Tweets'
            },
            followers: {
                type: metricEnums.dataType.INTEGER,
                description: strings.twitter_followers_description,
                axisFormat: function (value, metric, options) {
                    // NOTE if we are looking at absolute change we should
                    // format the axis ticks with +/- sign prefix
                    if (metric.timeAnalysisMode === metricEnums.timeAnalysisMode.DELTA_ABSOLUTE) {
                        return formatter.changeSignPrefix(value) + formatter.formatAbbreviated(value);
                    }

                    return formatter.formatAbbreviated(value, undefined, options);
                },
                summable: false
            },
            followers_to_following: {
                description: strings.twitter_followers_following_ratio_description,
                noHistoricData: true,
                summable: false
            },
            engagement_type: {
                // This defines the order these will appear in bar charts.
                dimensionValues: _.constant(['applause', 'conversation', 'amplification']),

                value: {
                    applause: {
                        format: utils.formatDimensionFn('Likes'),
                        className: 'twitter',

                        engagement_total: {
                            name: 'Likes',
                            description: function (val, metric) {
                                if (utils.useDetailsDescription(metric)) {
                                    return strings.twitter_tweet_details_favorites_description;
                                }
                                if (metric.dataSource === 'discovery') {
                                    return strings.discovery_twitter_tweets_favorites_description;
                                }
                                return strings.twitter_tweets_favorites_description;
                            }
                        },

                        avg_engagement_total_per_day: {
                            name: 'Likes / Day',
                            description: strings.twitter_average_daily_tweets_favorites_description
                        },

                        engagement_total_per_post: {
                            name: 'Likes / Tweet',
                            description: strings.twitter_likes_per_tweet_description,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        }
                    },
                    amplification: {
                        format: utils.formatDimensionFn('Retweets'),
                        className: 'x-twitter-secondary',
                        description: strings.twitter_tweets_retweets_description,

                        engagement_total: {
                            name: 'Retweets',
                            description: function (val, metric) {
                                if (utils.useDetailsDescription(metric)) {
                                    return strings.twitter_tweet_details_retweets_description;
                                }
                                if (metric.dataSource === 'discovery') {
                                    return strings.discovery_twitter_tweet_details_retweets_description;
                                }
                                return strings.twitter_tweets_retweets_description;
                            }
                        },

                        avg_engagement_total_per_day: {
                            name: 'Retweets / Day',
                            description: strings.twitter_average_daily_tweets_retweets_description
                        },

                        engagement_total_per_post: {
                            name: 'Retweets / Tweet',
                            description: strings.twitter_retweets_per_tweet_description,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        }
                    },
                    conversation: {
                        format: utils.formatDimensionFn('Replies'),
                        className: 'x-twitter-tertiary',
                        description: strings.twitter_tweets_replies_description,

                        engagement_total: {
                            name: 'Replies',
                            description: function (val, metric) {
                                if (utils.useDetailsDescription(metric)) {
                                    return strings.twitter_tweets_details_replies_description;
                                }
                                return strings.twitter_tweets_replies_description;
                            }
                        },

                        avg_engagement_total_per_day: {
                            name: 'Replies / Day',
                            description: strings.twitter_average_daily_replies_description
                        },

                        engagement_total_per_post: {
                            name: 'Replies / Tweet',
                            description: strings.twitter_replies_per_tweet_description,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        }
                    }
                }
            },
            count: {
                name: 'Tweets',
                description: function (val, metric) {
                    if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                        return strings.twitter_insights_tweets_description;
                    }

                    if (metric.key === 'SOCIAL_POSTS') {
                        return strings.twitter_tweets_description;
                    }

                    return strings.twitter_normal_tweets_description;
                }
            },
            'count / period': {
                name: 'Tweets / Day',
                description: strings.twitter_tweets_per_period_description
            },
            count_insights: {
                name: 'Tweets',
                description: strings.twitter_insights_tweets_description,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            posts_per_day: {
                name: 'Tweets / Day',
                description: strings.twitter_insights_posts_per_day_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                metricValueType: metricEnums.metricValueType.AVERAGE
            },
            posts_per_week: {
                name: 'Tweets / Week',
                description: strings.twitter_insights_posts_per_week_description,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                collection: metricEnums.collection.ACTIVITY,
                metricValueType: metricEnums.metricValueType.AVERAGE
            },
            media_type: {
                name: 'Post Type',
                type: metricEnums.dataType.STRING,
                description: strings.twitter_post_media_type_description
            },
            tweetType: {
                name: 'Tweet Type',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.STRING,
                value: {
                    normal: {
                        format: 'Normal',
                        className: 'twitter',
                        all_count: {
                            name: 'Tweets',
                            description: strings.twitter_normal_tweets_description
                        },
                        count: {
                            name: 'Tweets',
                            description: strings.twitter_normal_tweets_description
                        },
                        avg_count_per_day: {
                            name: 'Tweets / Day',
                            description: strings.twitter_average_daily_normal_tweets_description
                        },
                        avg_count_per_week: {
                            name: 'Tweets / Week',
                            description: strings.twitter_normal_avg_count_per_week_description
                        },
                        all_avg_count_per_day: {
                            name: 'Tweets / Day',
                            description: strings.twitter_average_daily_normal_tweets_description
                        }
                    },
                    retweet: {
                        format: 'Retweet',
                        className: 'x-twitter-secondary',
                        all_count: {
                            name: 'Retweet Tweets',
                            description: strings.twitter_retweet_tweets_description
                        },
                        count: {
                            name: 'Retweet Tweets',
                            description: strings.twitter_retweet_tweets_description
                        },
                        avg_count_per_day: {
                            name: 'Retweet Tweets / Day',
                            description: strings.twitter_average_daily_retweet_tweets_description
                        },
                        avg_count_per_week: {
                            name: 'Retweet Tweets / Week',
                            description: strings.twitter_retweet_avg_count_per_week_description
                        },
                        all_avg_count_per_day: {
                            name: 'Retweet Tweets / Day',
                            description: strings.twitter_average_daily_retweet_tweets_description
                        }
                    },
                    reply: {
                        format: 'Reply',
                        className: 'x-twitter-tertiary',
                        all_count: {
                            name: 'Reply Tweets',
                            description: strings.twitter_reply_tweets_description
                        },
                        count: {
                            name: 'Reply Tweets',
                            description: strings.twitter_reply_tweets_description
                        },
                        avg_count_per_day: {
                            name: 'Reply Tweets / Day',
                            description: strings.twitter_average_daily_reply_tweets_description
                        },
                        avg_count_per_week: {
                            name: 'Reply Tweets / Week',
                            description: strings.twitter_reply_avg_count_per_week_description
                        },
                        all_avg_count_per_day: {
                            name: 'Reply Tweets / Day',
                            description: strings.twitter_average_daily_reply_tweets_description
                        }
                    }
                },
                description: strings.twitter_post_tweet_type_description
            },
            all_count: {
                name: 'All Tweets',
                description: strings.twitter_all_tweets_description,
                metricCategory: metricEnums.category.ACTIVITY,
                collection: metricEnums.collection.ACTIVITY
            },
            lifetime_count: {
                name: 'Lifetime Tweets',
                description: strings.twitter_lifetime_tweets_description,
                collection: metricEnums.collection.ACTIVITY
            },
            lifetime_likes: {
                name: 'Lifetime Likes',
                description: strings.twitter_lifetime_likes_description
            },
            following: {
                description: strings.twitter_following_description,
                noHistoricData: true
            },
            overview: {
                name: 'Bio',
                description: strings.twitter_overview_description
            },
            overview_size: {
                name: 'Bio Length'
            },
            location: {
                name: 'Location',
                icon: 'map-marker',
                description: strings.twitter_location_description,
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.TEXT,
                emptyStringFormat: metricEnums.strings.EMPTY_TEXT
            },
            joined_at: {
                name: 'Joined Date',
                icon: 'calendar',
                format: function (data) {
                    const value = (_.isArray(data) ? _.last(data) : data);

                    if (!value) {
                        return '--';
                    }

                    return [
                        'Joined',
                        moment.utc(value).format('MMMM YYYY')
                    ].join(' ');
                }
            },
            url: {
                name: 'Profile URL',
                icon: 'link',
                description: strings.twitter_url_description,
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.TEXT,
                emptyStringFormat: metricEnums.strings.EMPTY_TEXT,
                format: function (data, metric, options) {
                    const value = (_.isArray(data) ? _.last(data) : data);

                    if (!value) {
                        return '--';
                    }

                    if (_.get(options, ['html'])) {
                        return [
                            `<a href="${value}" target="_blank">`,
                            value,
                            '</a>'
                        ].join('');
                    }

                    return value;
                }
            },
            listed_count: {
                name: 'Listed',
                description: strings.twitter_listed_count_description
            },
            presence_id: {
                name: 'Mentioner'
            },
            presence_handle: {
                format: function (data) {
                    const value = (_.isArray(data) ? _.last(data) : data);
                    return ['@', value].join('');
                }
            },
            icon_url: {
                format: function (data) {
                    let value = (_.isArray(data) ? _.last(data) : data);

                    if (_.isArray(value)) {
                        value = _.head(value);
                    }

                    if (!value || !_.isString(value)) {
                        return '--';
                    }

                    return value.replace(channel.get('lowResImgSuffix'), '');
                }
            },
            mentioned_companies: {
                name: 'Mentioned',
                type: metricEnums.dataType.STRING,
                metricType: metricEnums.metricType.TEXT,
                emptyStringFormat: metricEnums.strings.EMPTY_TEXT,
                csvFormat: function (mentioned) {
                    return _.get(mentioned, 'handles', []).join(',');
                },
                cellView: function () {
                    return RivalIQ.apps.Mentions.views.MentionedCell;
                }
            },
            // NOTE video_views and views below deliberately set no metricType: per-tweet video
            // views are volume and must sum across week/month rollups (CMPTE-414). metricType
            // TOTAL would make a rollup report the last daily value instead of the sum.
            video_views: {
                name: 'Video Views',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_video_views_description;
                        }
                        return strings.twitter_tweets_details_video_views_description;
                    } else if (metric.dataSource === 'insightsPost') {
                        return strings.twitter_insights_video_views_description;
                    }
                    return strings.twitter_tweets_video_views_description;
                },
                category: 'post_analysis',
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            // used for ES mappings
            views: {
                name: 'Video Views',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_video_views_description;
                        }
                        return strings.twitter_tweets_details_video_views_description;
                    }
                    return strings.twitter_tweets_video_views_description;
                },
                category: 'post_analysis',
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            video_views_per_day: {
                name: 'Video Views / Day',
                description: strings.twitter_average_daily_tweets_video_views_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                type: metricEnums.dataType.NUMERIC
            },
            video_views_per_tweet: {
                name: 'Video Views / Tweet',
                description: strings.twitter_average_tweets_video_views_per_post_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                type: metricEnums.dataType.NUMERIC
            },
            impressions: {
                name: 'Impressions',
                description: function (val, metric) {
                    return (utils.useDetailsDescription(metric) ? strings.twitter_post_impressions_description : strings.twitter_impressions_description);
                },
                category: 'post_analysis', // this makes this metric show up in the post modal
                collection: metricEnums.collection.IMPRESSIONS,
                type: metricEnums.dataType.INTEGER
            },
            impressions_insights: {
                name: 'Impressions',
                description: function (val, metric) {
                    return (utils.useDetailsDescription(metric) ? strings.twitter_post_impressions_description : strings.twitter_impressions_description);
                },
                collection: metricEnums.collection.IMPRESSIONS,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            impressions_per_post: {
                name: 'Impressions / Tweet',
                description: strings.twitter_insights_impressions_per_post_description,
                collection: metricEnums.collection.IMPRESSIONS,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            likes: {
                name: 'Likes',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_likes_description;
                        }
                    }
                    return strings.twitter_insights_likes_description;
                },
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            likes_per_post: {
                name: 'Likes / Tweet',
                description: strings.twitter_insights_likes_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            retweets: {
                name: 'Retweets',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_retweets_description;
                        }
                    }
                    return strings.twitter_insights_retweets_description;
                },
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            retweets_per_post: {
                name: 'Retweets / Tweet',
                description: strings.twitter_insights_retweets_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            replies: {
                name: 'Replies',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_replies_description;
                        }
                    }
                    return strings.twitter_insights_replies_description;
                },
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            replies_per_post: {
                name: 'Replies / Tweet',
                description: strings.twitter_insights_replies_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            clicks: {
                name: 'Clicks',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_clicks_description;
                        }
                    }

                    return strings.twitter_insights_clicks_description;
                },
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            clicks_per_post: {
                name: 'Clicks / Tweet',
                description: strings.twitter_insights_clicks_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            video_views_per_post: {
                name: 'Video Views / Tweet',
                description: strings.twitter_insights_video_view_per_post_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                type: metricEnums.dataType.NUMERIC,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            video_views_insights: {
                name: 'Video Views',
                description: strings.twitter_insights_video_views_description,
                type: metricEnums.dataType.INTEGER,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                source: metricEnums.sources.TWITTER_INSIGHTS
            },
            following_insights: {
                name: 'Following',
                type: metricEnums.dataType.INTEGER,
                description: strings.twitter_following_description,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                metricType: metricEnums.metricType.TOTAL,
                noHistoricData: true,
                collection: metricEnums.collection.AUDIENCE
            },
            followers_insights: {
                name: 'Followers',
                type: metricEnums.dataType.INTEGER,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                metricType: metricEnums.metricType.TOTAL,
                noHistoricData: true,
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        if (metric.source === metricEnums.sources.TWITTER_INSIGHTS) {
                            return strings.twitter_insights_post_presence_reach_description;
                        }
                    }
                    return strings.twitter_followers_description;
                },
                axisFormat: function (value, metric, options) {
                    // NOTE if we are looking at absolute change we should
                    // format the axis ticks with +/- sign prefix
                    if (metric.timeAnalysisMode === metricEnums.timeAnalysisMode.DELTA_ABSOLUTE) {
                        return formatter.changeSignPrefix(value) + formatter.formatAbbreviated(value);
                    }

                    return formatter.formatAbbreviated(value, undefined, options);
                },
                collection: metricEnums.collection.AUDIENCE
            },
            followers_to_following_insights: {
                name: 'Followers / Following Ratio',
                type: metricEnums.dataType.NUMERIC,
                description: strings.twitter_followers_following_ratio_description,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                metricType: metricEnums.metricType.TOTAL,
                noHistoricData: true,
                collection: metricEnums.collection.AUDIENCE,
                summable: false
            },
            lifetime_count_insights: {
                name: 'Lifetime Tweets',
                description: strings.twitter_lifetime_tweets_description,
                metricType: metricEnums.metricType.TOTAL,
                collection: metricEnums.collection.ACTIVITY,
                source: metricEnums.sources.TWITTER_INSIGHTS,
                type: metricEnums.dataType.INTEGER
            }
        };
    }
})();
